//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"Bodies",0,"ScCollector",0],[0,"CoordinateSystem",1,"CoordinateSystem",0],[0,"Freedom",1,0],[0,"MaxAngle",1,0],[0,"Offset",1,0],[1,"OffsetExpression",0,"Expression",0],[0,"Type",1,0]],[],[]];
SPLM.Features.PrintCsysBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.PrintCsysBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.PrintCsysBuilder.Types = Object.freeze({
    "UserDefined" : "UserDefined", "MinimumHeight" : "MinimumHeight"});

SPLM.Features.PrintCsysBuilder.FreedomType = Object.freeze({
    "Free" : "Free", "FixZDirection" : "FixZDirection", "FixBottomPlane" : "FixBottomPlane", "Rotate180" : "Rotate180", "FixBottomandXY" : "FixBottomandXY", "FixRotation" : "FixRotation", "Fixed" : "Fixed"});

export default SPLM;